import { __assign, __extends } from "tslib";
import React from "react";
import { View, Text, Image } from "react-native";
import PropTypes from "prop-types";
import PnmacMenu from "../Menu/PnmacMenu";
import PnmacPaper from "../Paper/PnmacPaper";
import MenuItem from "../Menu/PnmacMenuItem";
import Divider from "../Divider";
import styles from "./PnmacLoanSwitcher.styles.js";
import { textStyle } from '../v2/theme';
var PnmacLoanSwitcherMenu = /** @class */function (_super) {
  __extends(PnmacLoanSwitcherMenu, _super);
  function PnmacLoanSwitcherMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      openModal: false
    };
    return _this;
  }
  PnmacLoanSwitcherMenu.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      loans = _a.loans,
      onValueChange = _a.onValueChange,
      selectedValue = _a.selectedValue,
      underLineColor = _a.underLineColor,
      downIcon = _a.downIcon,
      upIcon = _a.upIcon,
      loanStyles = _a.loanStyles,
      isMobile = _a.isMobile,
      outerContainerStyles = _a.outerContainerStyles;
    var selectedLoan = selectedValue ? this.props.loans.find(function (_a) {
      var loanId = _a.loanId;
      return loanId == selectedValue;
    }) || loans[0] : loans[0];
    return /*#__PURE__*/React.createElement(View, {
      style: {
        width: isMobile ? "100%" : "auto"
      },
      testID: "loanSwitcherMenu"
    }, /*#__PURE__*/React.createElement(PnmacMenu, __assign({
      visible: this.state.openModal,
      menuContainerStyles: outerContainerStyles || styles.container,
      onDismiss: function () {
        return _this.setState({
          openModal: false
        });
      }
    }, this.props, {
      anchor: /*#__PURE__*/React.createElement(PnmacPaper, {
        activate: true,
        containerStyles: {
          padding: 10,
          alignItems: "center",
          shadowOffset: {
            width: 2,
            height: 4
          },
          shadowColor: "#262626",
          shadowOpacity: 0.2,
          shadowRadius: 5,
          elevation: 1,
          borderRadius: 10
        },
        onPress: function () {
          return _this.setState({
            openModal: !_this.state.openModal
          });
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%"
        }
      }, this.state.openModal ? (/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
        style: __assign(__assign({}, textStyle.loanSelector), {
          marginBottom: 0,
          textDecorationLine: "underline",
          textDecorationStyle: "solid",
          textDecorationColor: underLineColor || "black",
          textAlign: "center"
        })
      }, "Select your loan"))) : (/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
        style: __assign(__assign({}, textStyle.loanSelector), {
          marginBottom: 0,
          textDecorationLine: "underline",
          textDecorationStyle: "solid",
          textDecorationColor: underLineColor || "black",
          textAlign: "center"
        })
      }, "Select your loan"), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
        style: [__assign({
          marginBottom: 0
        }, textStyle.loanSelector), loanStyles]
      }, (parseInt(selectedLoan.lienPriorityType) === 2 ? 'Closed End Second' : 'LOAN') + " - " + selectedLoan.loanId), /*#__PURE__*/React.createElement(Text, null, selectedLoan.propertyStreet)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, this.state.openModal ? upIcon || "▲" : downIcon || "▼")))))))
    }), loans.map(function (loan, i) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: i
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: i % 2 === 0 ? "#EFEFEF" : "#FFF"
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        titleStyle: {
          fontWeight: "500",
          marginBottom: 0
        },
        onPress: function () {
          _this.setState({
            openModal: !_this.state.openModal
          }, function () {
            return onValueChange(loan.loanId);
          });
        },
        title: loan.displayTitle,
        subtitle: loan.propertyStreet
      }), /*#__PURE__*/React.createElement(Text, {
        style: textStyle.loanSelector
      }, loan.loanId === selectedLoan.loanId ? "✓" : " ")));
    })));
  };
  return PnmacLoanSwitcherMenu;
}(React.Component);
PnmacLoanSwitcherMenu.propTypes = {
  loanIds: PropTypes.array,
  onValueChange: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  address: PropTypes.string
};
export default PnmacLoanSwitcherMenu;